var map = {
	"./battery_2blue.png": "b126",
	"./battery_2classic.png": "7ea0",
	"./battery_2disable.png": "82fc",
	"./battery_2green.png": "04e4",
	"./battery_2orange.png": "a46c",
	"./battery_2purple.png": "720c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "659d";